import React from "react";

import ChatModal from "../ChatModal";
import "./chaticon.style.css";

interface IChatIconProps {
  roomId: string;
  id: number;
  category: "estimate" | "order";
  isModalActive?: boolean;
  setIsModalActive?: any;
  orderNumber?: any;
}
export default function ChatIcon(props: IChatIconProps) {
  const [isModalActive, setIsModalActive] = React.useState(false);
  const [hasUnreadMessages, setHasUnreadMessages] =
    React.useState<boolean>(false);

  const changeVisibility = (status: boolean) => {
    props.setIsModalActive
      ? props.setIsModalActive(status)
      : setIsModalActive(status);
  };

  return (
    <React.Fragment>
      <div className="quote-chat" onClick={() => changeVisibility(true)}>
        <svg
          width="21"
          height="19"
          viewBox="0 0 21 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.5 0C4.70039 0 0 3.86052 0 8.625C0 10.6817 0.877734 12.5643 2.33789 14.0447C1.8252 16.1346 0.110742 17.9964 0.0902344 18.0171C0 18.1125 -0.0246094 18.2535 0.0287109 18.3779C0.0820312 18.5023 0.196875 18.5769 0.328125 18.5769C3.04746 18.5769 5.08594 17.2583 6.09492 16.4456C7.43613 16.9556 8.925 17.25 10.5 17.25C16.2996 17.25 21 13.3895 21 8.625C21 3.86052 16.2996 0 10.5 0ZM11.8125 10.9471C11.8125 11.1296 11.6648 11.2788 11.4844 11.2788H5.57812C5.39766 11.2788 5.25 11.1296 5.25 10.9471V10.2837C5.25 10.1012 5.39766 9.95192 5.57812 9.95192H11.4844C11.6648 9.95192 11.8125 10.1012 11.8125 10.2837V10.9471ZM15.4219 7.29808C15.6023 7.29808 15.75 7.1488 15.75 6.96635V6.30288C15.75 6.12043 15.6023 5.97115 15.4219 5.97115H5.57812C5.39766 5.97115 5.25 6.12043 5.25 6.30288V6.96635C5.25 7.1488 5.39766 7.29808 5.57812 7.29808H15.4219Z"
            fill="white"
          />
        </svg>
        {hasUnreadMessages && <div className="quote-chat-new" />}
      </div>
      <ChatModal
        category={props.category}
        roomId={props.roomId}
        activeData={{
          id: props.id,
          roomId: props.roomId,
        }}
        orderNumber={props.orderNumber}
        isVisible={props.isModalActive ?? isModalActive}
        changeVisibility={changeVisibility}
        setHasUnreadMessages={setHasUnreadMessages}
      />
    </React.Fragment>
  );
}
